// extracted by mini-css-extract-plugin
export default {"container":"UnexpectedErrorPage_container__HXFiD","heading":"UnexpectedErrorPage_heading__Ft8Yb"};